import React from 'react';
import LocationTemplate from './LocationTemplate';

const WardenPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Warden"
      stateName="North Carolina"
      countyName="Nash"
      zipCodes={["27893"]}
      latitude={35.9534}
      longitude={-77.9678}
      population={42}
      historicalFact="One of North Carolina's smallest incorporated towns, established in the early 1900s."
      nearbyTowns={[
        "Rocky Mount, NC",
        "Nashville, NC",
        "Spring Hope, NC",
        "Bailey, NC",
        "Castalia, NC",
        "Elm City, NC",
        "Red Oak, NC",
        "Middlesex, NC"
      ]}
    />
  );
};

export default WardenPage;